export const FLOW_TEMPLATE_EVENT_NAMES = {
    stepKeyApplied: 'step_key_applied',
    stepKeyConflict: 'step_key_conflict',
    stepKeysCompleted: 'step_keys_completed',
    templateExportFailed: 'template_export_failed',
} as const

export type FlowTemplateEventName = typeof FLOW_TEMPLATE_EVENT_NAMES[keyof typeof FLOW_TEMPLATE_EVENT_NAMES]

export type FlowTemplateEvent =
    | {
        name: typeof FLOW_TEMPLATE_EVENT_NAMES.stepKeyApplied
        stepId: number
        key: string
    }
    | {
        name: typeof FLOW_TEMPLATE_EVENT_NAMES.stepKeyConflict
        stepId: number
        keys: string[]
    }
    | {
        name: typeof FLOW_TEMPLATE_EVENT_NAMES.stepKeysCompleted
        applied: number
        skipped: number
        conflicted: number
    }
    | {
        name: typeof FLOW_TEMPLATE_EVENT_NAMES.templateExportFailed
        reason: string
    }

export function flowTemplateEventPrefix(templateId: number): string {
    return `flow_template:${templateId}`
}

export function flowTemplateEventType(templateId: number, name: FlowTemplateEventName): string {
    return `${flowTemplateEventPrefix(templateId)}:${name}`
}
